import { render, staticRenderFns } from "./ptPrivacy.vue?vue&type=template&id=d9ff6aac&scoped=true&"
import script from "./ptPrivacy.vue?vue&type=script&lang=js&"
export * from "./ptPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ptPrivacy.vue?vue&type=style&index=0&id=d9ff6aac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ff6aac",
  null
  
)

export default component.exports